import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/project/projectsApi";
import { useAddTaskMutation } from "../../features/task/taskApi";
import { useGetTeamsQuery } from "../../features/team/teamsApi";

export default function AddTask() {
  const [addTask] = useAddTaskMutation();
  // get team members form rtq query
  const { data: teamMembers } = useGetTeamsQuery();
  // get project
  const { data: projects } = useGetProjectsQuery();

  const [taskName, setTaskName] = useState("");
  const [teamMemberId, setTeamMemberId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [deadline, setDeadline] = useState("");

  const navigate = useNavigate();

  const handleAddTask = (e) => {
    e.preventDefault();
    const newTask = {
      taskName,
      teamMember: teamMembers.find(
        (member) => member.id === parseInt(teamMemberId)
      ),
      project: projects.find((project) => project.id === parseInt(projectId)),
      deadline,
    };

    addTask(newTask);
    navigate("/");
  };

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleAddTask}>
            <div className="fieldContainer">
              <label for="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                name="teamMember"
                id="lws-teamMember"
                required
                onChange={(e) => setTeamMemberId(e.target.value)}
              >
                <option value="" hidden selected>
                  Select Member
                </option>
                {teamMembers?.map((member) => (
                  <option key={member.id} value={member.id}>
                    {member.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="fieldContainer">
              <label for="lws-projectName">Project Name</label>
              <select
                id="lws-projectName"
                name="projectName"
                required
                onChange={(e) => setProjectId(e.target.value)}
              >
                <option value="" hidden selected>
                  Select Project
                </option>
                {projects?.map((project) => (
                  <option key={project.id} value={project.id}>
                    {project.projectName}
                  </option>
                ))}
              </select>
            </div>

            <div className="fieldContainer">
              <label for="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
